export default "__VITE_ASSET__CEaLGlNA__"